export default "__VITE_ASSET__DNy_Bm5F__"